import { CheckCircle } from 'lucide-react';
import { getText } from '@/translate/text';

export default function UsersList({
  users = [],
  hasBorder = true,
  onAdd,
  isAdded,
  fromUserSelection = false,
}) {
  return (
    <div className="space-y-2">
      {users.map((user) => {
        const added = typeof isAdded === 'function' ? isAdded(user._id) : false;

        return (
          <div
            key={user._id}
            className={`flex items-center justify-between rounded-xl p-3 ${
              hasBorder ? 'border' : ''
            }`}
          >
            <div>
              <div className="flex items-center gap-2">
                <p className="font-medium text-sm">
                  {user.first_name} {user.last_name}
                </p>
                {user.external_user_id && (
                  <div className="px-3 py-1 bg-primary-50 rounded-lg flex items-center justify-center">
                    <p className="text-sm text-primary-600">ID: {user.external_user_id}</p>
                  </div>
                )}
              </div>
              {user.mobile_number && <p className="text-xs text-gray-500">{user.mobile_number}</p>}
            </div>

            {added ? (
              <button className="bg-primary-700 text-white px-3 py-1 rounded-lg text-sm flex items-center gap-1">
                <CheckCircle className="w-3 h-3 text-white" /> {getText('added') || 'Added'}
              </button>
            ) : (
              <button
                onClick={() => {
                  if (!onAdd) return;
                  const dataToPass = fromUserSelection ? user : user._id;
                  onAdd(dataToPass);
                }}
                className="border border-primary-700 text-primary-700 px-3 py-1 rounded-lg text-sm hover:bg-primary-50"
              >
                + {getText('add') || 'Add'}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
